// 1. Updated Helper Function (Place this at the very top)
function filterShopifyEvent(event, element, callback) {
  const target = event.target;
  // Check if the event target is the element, contains the element (parent section selected),
  // or is contained by the element.
  if (target === element || target.contains(element) || element.contains(target)) {
    callback(event);
  }
}

class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === "/challenge") {
      return;
    }

    // --- PAGE FILTERING LOGIC ---
    this.hidePopup = false;
    this.hideOnPages = this.dataset.pages;
    this.hideOnPages = this.hideOnPages ? this.hideOnPages.split(",") : [];
    this.hideOnPages = this.hideOnPages.filter((page) => page);
    this.hideOnPages = this.hideOnPages.map((page) => page.trim());
    this.pathname = window.location.pathname;
    this.hideOnPages.forEach((page) => {
      if (this.pathname.includes(page)) {
        this.hidePopup = true;
      }
    });
    if (this.hidePopup) {
      return;
    }

    this.cookieName = "beyours:promo-popup";
    this.classes = {
      bodyClass: "promo-popup--open",
      activeClass: "is-active",
      closingClass: "is-closing",
      showImage: "show-image",
    };

    this.popup = this.querySelector(".promo-popup");

    this.querySelectorAll("[data-popup-toggle]").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    // --- FIX IS HERE ---
    // 1. Check if we are in the Theme Editor
    const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    // 2. ONLY run init() if we are NOT in the editor.
    // In the editor, the connectedCallback events will handle opening it when clicked.
    if (!isDesignMode) {
      if (
        !this.getCookie(this.cookieName) ||
        this.dataset.testMode === "true" ||
        this.getQueryParam("force-show-popup")
      ) {
        this.init();
      }
    }
  }

  getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  connectedCallback() {
    // Only add these listeners if we are in the editor
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      
      document.addEventListener("shopify:section:load", this.onShopifySectionLoad);
      document.addEventListener("shopify:section:select", this.onShopifySectionSelect);
      document.addEventListener("shopify:section:deselect", this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.removeEventListener("shopify:section:load", this.onShopifySectionLoad);
      document.removeEventListener("shopify:section:select", this.onShopifySectionSelect);
      document.removeEventListener("shopify:section:deselect", this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }

  onSectionLoad(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  init() {
    setTimeout(
      function () {
        this.open();
      }.bind(this),
      parseInt(this.dataset.delay) * 1000
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass)
      ? this.close()
      : this.open();
  }

  open() {
    document.body.classList.add(this.classes.bodyClass);
    this.classList.remove('hidden');
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 6);
    
    if (this.popup.dataset.position === "center") {
       if(typeof setScrollbarWidth === 'function') setScrollbarWidth();
    }

    const popupEl = document.querySelector('.promo-popup');
    if (popupEl) {
      let popupType = 'Small Newsletter Popup';
      if (popupEl.classList.contains('popup-theme--full')) {
        popupType = 'Full Newsletter Popup';
      } else if (popupEl.classList.contains('popup-theme--medium')) {
        popupType = 'Medium Newsletter Popup';
      }
      window.igEvents = window.igEvents || [];
      window.igEvents.push({
        event: "javascripteventDPTPW",
        popupSize: popupType
      });
    }

    const popupType = this.getQueryParam("popup-type");
    if (popupType) {
      const currentClasses = Array.from(this.popup.classList);
      currentClasses.forEach(cls => {
        if (cls.startsWith('popup-theme--') || cls.startsWith('theme-')) {
          this.popup.classList.remove(cls);
        }
      });
      this.popup.classList.add(`popup-theme--${popupType}`);
      if (popupType === "small") {
        this.popup.classList.add("theme-dark");
      } else {
        this.popup.classList.add("theme-light");
      }
    }
    document.body.classList.add('lock-all');
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);
    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);
      document.body.classList.remove(this.classes.bodyClass);
      this.classList.add('hidden');
    }, 5);

    if (this.dataset.testMode === "true") {
      this.removeCookie(this.cookieName);
      return;
    }

    document.body.classList.remove('lock-all');
    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }

  afterSubmit() {
    if (this.dataset.testMode === "true") {
      this.removeCookie(this.cookieName);
      return;
    }
    this.setCookie(this.cookieName, this.dataset.expiry);
  }
}
customElements.define("promo-popup", PromoPopup);

// (KlaviyoSub class remains unchanged below)
class KlaviyoSub extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector("[data-mi-submit]");
    this.emailEl = this.querySelector('input[name="email"]');
    this.successBtn = this.querySelector(".on-success-btn.alh-on-success-btn");
    if(this.submitBtn) this.submitBtn.addEventListener("click", this.handleSubmit.bind(this));
    if(this.emailEl) this.emailEl.addEventListener("input", () => {
      this.emailEl.classList.remove("invalid");
    });
    if(this.successBtn) this.successBtn.addEventListener("click", (event) => {
      event.preventDefault();
      const promoPopup = document.querySelector("promo-popup");
      if (promoPopup) {
        promoPopup.close();
      }
    });

    if (!this.dataset.listId) {
      this.setAttribute("hidden", "hidden");
      console.error("Please provide a list ID");
      return;
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.toggleButton(true);

    const email = this.emailEl.value;
    if (!this.validateEmail(email)) {
      this.emailEl.focus();
      this.emailEl.classList.add("invalid");
      this.toggleButton(false);
      return;
    }

    var fetchConfigs = {
      crossDomain: true,
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        Accept: "application/json",
      },
      body: new URLSearchParams({
        a: "ME79pB",
        g: this.dataset.listId,
        email: email,
      }),
    };

    fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", fetchConfigs)
      .then((response) => {})
      .catch((error) => {
        this.toggleButton(false);
      })
      .finally(() => {
        this.toggleButton(false);
        this.emailEl.value = "";
        this.setAttribute("success", "");
        this.hidePopupText();
        this.callParent();

        const popup = document.querySelector('.promo-popup');
        if (popup) {
          let popupType = 'Small Newsletter Popup';
          if (popup.classList.contains('popup-theme--full')) {
            popupType = 'Full Newsletter Popup';
          } else if (popup.classList.contains('popup-theme--medium')) {
            popupType = 'Medium Newsletter Popup';
          }
          window.igEvents = window.igEvents || [];
          window.igEvents.push({
            event: "javascripteventWWOFX",
            popupSize: popupType
          });
        }
      });
  }

  hidePopupText() {
    if (window.innerWidth < 768) {
      const popupText = document.querySelector(".popup__text.rte");
      if (popupText) {
        popupText.style.display = "none";
      }
    }
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  toggleButton(disabled) {
    if (disabled) {
      this.submitBtn.setAttribute("disabled", "disabled");
      this.submitBtn.classList.add("is-loading");
    } else {
      this.submitBtn.removeAttribute("disabled");
      this.submitBtn.classList.remove("is-loading");
    }
  }

  callParent() {
    const promoPopup = this.closest("promo-popup");
    if (promoPopup) {
      promoPopup.afterSubmit();
    }
  }
}
customElements.define("klaviyo-sub", KlaviyoSub);